import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHead from "./SectionHead";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const FAQ = () => {
  const { d } = useLang();
  return (
    <section className="bg-paper py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead overline={d.faq.overline} title={d.faq.title} />
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <Accordion type="single" collapsible className="w-full">
                {d.faq.items.map((item, i) => (
                  <AccordionItem key={i} value={`faq-${i}`} className="border-ink/10">
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i}`}
                      className="py-5 text-left font-serif text-xl font-normal text-ink hover:text-accent hover:no-underline"
                    >
                      <span className="flex items-baseline gap-4">
                        <span className="font-mono text-xs text-mutedink">{String(i + 1).padStart(2, "0")}</span>
                        {item.q}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 pl-9 text-base leading-relaxed text-mutedink" data-testid={`faq-content-${i}`}>
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
